import React from 'react'
import { FaqDetailTemplate } from '@next-nx/shared-ui/templates'
import { initializeApollo } from '../../client'
import {
  CategoriaFaqDocument,
  CategorieFaqDocument,
  PaginaDocument,
} from '@next-nx/shared-graphql/vita'
import { NextWrapper } from 'apps/next-vita/data-fetching-wrapper'

function FaqDetail({ pagina, categorieFaq, categoriaFaq, domanda }) {
  return (
    <FaqDetailTemplate
      pagina={pagina}
      categorieFaq={categorieFaq}
      categoria={categoriaFaq}
      domanda={domanda}
    />
  )
}

export const getServerSideProps = NextWrapper.getServerSideProps(async ({ params: { slug } }) => {
  const client = initializeApollo()

  let categorie = []
  const categoria = slug[0] || null
  const domanda = slug[1] || null

  const {
    data: { pagina },
  } = await client.query({
    query: PaginaDocument,
    variables: { chiave: 'faq-detail' },
  })

  if (!pagina) {
    return {
      notFound: true,
    }
  }

  try {
    const {
      data: { categorieFaq },
    } = await client.query({
      query: CategorieFaqDocument,
    })

    if (!categorieFaq) {
      return {
        notFound: true,
      }
    }

    if (categoria && !categorieFaq.edges.find((item) => item.node.slug === categoria)) {
      return {
        notFound: true,
      }
    }

    if (categorieFaq?.edges.length) {
      categorie = categorieFaq.edges.map((item) => ({
        ...item.node,
        active: categoria === item.node.slug,
      }))
    }

    const {
      data: { categoriaFaq },
    } = await client.query({
      query: CategoriaFaqDocument,
      variables: {
        slug: categoria,
      },
    })

    if (domanda && !categoriaFaq.faq.find((item) => item.slug === domanda)) {
      return {
        notFound: true,
      }
    }

    return {
      props: { pagina: pagina, categorieFaq: categorie, categoriaFaq: categoriaFaq, domanda }, // will be passed to the page component as props
    }
  } catch {
    return {
      props: { pagina: pagina },
    }
  }
})

export default FaqDetail
